// Settings → Notifications rows, as shown on www (desk Settings mock):
// "New booking: Email + push", "Delivery ready: Email", "Weekly digest · Monday 8:00".
// Values come from GET /api/settings/notifications; nothing here is pretend state.

export const NOTIF_ROWS = [
  { key: 'new_booking', label: 'New booking', sub: 'When a shoot you booked is confirmed', channels: [
    { field: 'new_booking_email', label: 'Email' },
    { field: 'new_booking_push', label: 'Push' },
  ] },
  { key: 'delivery_ready', label: 'Delivery ready', sub: 'When your photos, tour or floor plan are delivered', channels: [
    { field: 'delivery_ready_email', label: 'Email' },
  ] },
  { key: 'weekly_digest', label: 'Weekly digest', sub: 'Monday 8:00 AM · your desk numbers for the week', digest: true, channels: [
    { field: 'weekly_digest', label: 'Email' },
  ] },
];

export const NOTIF_FIELDS = NOTIF_ROWS.flatMap(r => r.channels.map(c => c.field));

export const NOTIF_DEFAULTS = {
  new_booking_email: true,
  new_booking_push: true,
  delivery_ready_email: true,
  weekly_digest: false,
};

// Property accounts (builders, REITs, investors, commercial, property
// managers) book visits and get site files, not listing shoots.
const PROPERTY_KINDS = ['builder', 'reit_leasing', 'investor', 'commercial', 'property_manager'];
const PROPERTY_SUBS = {
  new_booking: 'When a visit you booked is confirmed',
  delivery_ready: 'When the files from a visit are delivered',
  weekly_digest: 'Monday 8:00 AM · a summary of your week',
};

// Photographers have no desk, so they get no desk digest row.
export function rowsFor(kind) {
  if (kind === 'platform') return [];
  if (kind === 'vendor' || kind === 'photographer') return NOTIF_ROWS.filter(r => !r.digest);
  if (PROPERTY_KINDS.includes(kind)) return NOTIF_ROWS.map(r => ({ ...r, sub: PROPERTY_SUBS[r.key] || r.sub }));
  return NOTIF_ROWS;
}

export function fromServer(data) {
  const out = { ...NOTIF_DEFAULTS };
  for (const f of NOTIF_FIELDS) {
    if (data && typeof data[f] === 'boolean') out[f] = data[f];
  }
  return { prefs: out, stored: !!(data && data.stored) };
}

// Optimistic flip; returns [nextPrefs, patchBody].
export function flip(prefs, field) {
  if (!NOTIF_FIELDS.includes(field)) throw new Error(`unknown notification field ${field}`);
  const next = { ...prefs, [field]: !prefs[field] };
  return [next, { [field]: next[field] }];
}
